import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import { Nav, Tab, Row, Col, Container, Form } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-datetime/css/react-datetime.css";
import Accordion from "react-bootstrap/Accordion";
import { useParams, useHistory } from "react-router-dom";
import useAxiosFile from "../../actions/useaxios";
import config from "../../actions/config";
import axios from 'axios';
import {
  DecryptData,
  EncryptData,
  MinuteHourFormat,
  isEmpty,
} from "../../actions/common";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import {
  GetLatLngBasedOnAddress,
  GetAddressBasedOnLatLng,
} from "../Map/geocode";

// import deletSvg from "";

function LocationAction() {
  const initdata = {
    FirstName: "",
    LastName: "",
    EmailId: "",
    Mobile: "",
    DateofBirth: "",
    Gender: "",
    Profile: "",
  };

  const { token, payload } = useSelector((state) => state.admin_panel.User);
  const { toggle } = useSelector((state) => state.admin_panel.User);
  const location = useLocation();
  const { pathname, search, state } = useLocation();

  const [formValue, setFormValue] = useState({});
  const [Error, SetError] = useState({});
  const [activeTab, setActiveTab] = useState("profile");
  const [id, Setid] = useState("");
  const [Disable, SetDisable] = useState(false);

  console.log("dfgd", token, location?.search);

  const navigate = useNavigate();

  const axiosFile = useAxiosFile();

  const OnChange = (e) => {
    SetError({})
    let { id, value } = e?.target;
    setFormValue({ ...formValue, [id]: value });
  };

  useEffect(() => {
    if (location?.search) {
      let paramdata = location.search.split("?Id=")[1];
      console.log("llsflklfk", DecryptData(paramdata));
      if (paramdata) {
        let decstring = DecryptData(paramdata);
        if (decstring) {
          if (decstring == "add") {
            setFormValue({ ...formValue, action: decstring });
          } else {
            GetData(decstring);
          }
          Setid(
            isEmpty(DecryptData(paramdata)) ? paramdata : DecryptData(paramdata)
          );
        } else {
          navigate("/locations");
        }
      } else {
        navigate("/locations");
      }
    }
  }, [location?.search]);

  const GetData = async (id) => {
    let Resp = await axiosFile.LocationAction({
      action: "getid",
      from: "admin",
      id: id,
    });
    console.log("respppppp", Resp);
    if (Resp?.status) {
      setFormValue({
        ZipCode: Resp?.data?.ZipCode,
        action: "edit",
        id: id,
        City: Resp?.data?.City,
      });
    } else {
      toast.error("Invalid Datas");
      navigate("/locations");
    }
  };

  const Validation = async () => {
    let data = {error:{},geometry:{}};
    if (isEmpty(formValue?.City)) {
      data.error.City = "Enter City";
    } 
    if(isEmpty(formValue?.ZipCode)){
      data.error.ZipCode = "Enter ZipCode";
    }
    else {

      let Check = await GetLatLngBasedOnAddress(
        String(formValue?.ZipCode)?.trim()
      );
      console.log("CheckCheck", Check, formValue?.ZipCode);
      if(Check?.error){
        data.error.ZipCode = Check?.error?.includes("ZERO_RESULTS") ? "Enter Valid Zip Code" : Check?.error;
      }
      else{
        data.geometry = await getZipCodeBounds( formValue?.ZipCode );
      }

      console.log('boundbound',data)
      // process.env.geoapikey

      

      // if(Check?.coordinates?.every((val)=>val==0)){
      //   error.ZipCode = "Enter Valid ZipCode"
      // }
      // else{
      //   let zipcodecheck = await GetAddressBasedOnLatLng(Check?.coordinates?.[0],Check?.coordinates?.[1])
      //   console.log('zipcodecheck',zipcodecheck)
      //   if(zipcodecheck?.Zipcode != formValue?.ZipCode){
      //     error.ZipCode = "Enter Valid ZipCode"
      //   }
      // }
    }
    return data;
  };

  const getZipCodeBounds = async (zipCode) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=AIzaSyDT9jQZ5BhdkR8dUwZFtdJKdi82PaBT_h8`;
    try {
      const response = await axios.get(url);
      const data = response.data;
      if (data.status === 'OK' && data.results.length > 0) {
        return data.results[0].geometry;
      }
      else {
        return undefined;
      }
    } catch (error) {
      console.error('Error fetching bounds:', error);
      return undefined;
    }
  };

  const Submit = async () => {
    SetDisable(true);
    let Validate = await Validation();
    if (isEmpty(Validate.error)) {
      let senddata = formValue;
      senddata.geometry = Validate.geometry;
      senddata.location = { type: "point", coordinates: [ Validate.geometry.location.lng, Validate.geometry.location.lat ]};
      senddata.ZipCode = senddata.ZipCode.toLowerCase();
      let toastid = toast.loading(
        senddata.action == "add" ? "Saving" : "Updating"
      );
      senddata.from = "admin";
      let Resp = await axiosFile.LocationAction(senddata);

      if (Resp?.status) {

        toast.update(toastid, {
          type: "success",
          render:
            Resp?.msg && typeof Resp?.msg == "string"
              ? Resp?.msg
              : "Completed Succesfully",
          isLoading: false,
          autoClose: 1000,
        });
        setFormValue({});
        navigate("/locations");
      } else {
        toast.update(toastid, {
          type: "error",
          render:
            Resp?.msg && typeof Resp?.msg == "string" ? Resp?.msg : "Try Again",
          isLoading: false,
          autoClose: 1000,
        });
      }
    } else {
      toast.error("Fix all Validations")
      SetError(Validate.error);
    }
    SetDisable(false);
  };

  return (
    <>
      <div>
        <div className="innerpages">
          <div className="orders_pages">
            <Headers />
            <div className="container custom_container px-lg-0">
              <div className="row mx-auto">
                <div className="innerpages_wid px-0">
                  <Sidebar />
                  <div
                    className={
                      toggle
                        ? "content-sec-inner right_widthset content_without_sidebar"
                        : "content-sec-inner  content_with_sidebar"
                    }
                  >
                    <section id="content-wrapper">
                      <div class="row">
                        <div className="top_title_sec">
                          <div>
                            {" "}
                            <p className="page_title">Add Location</p>
                          </div>
                        </div>
                      </div>
                      {/* profile details */}
                      <div className=" mt-4">
                        {/* <div className="mdvsec_border sec_border">
                          <div className="row mdv_driverdtls_whole">
                            <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-12 col-12"></div>
                          </div>
                          <div className="mdv_drivertab jus_start">
                            <p className={"mdv_tabtext active"}>ZipCode</p>
                          </div>
                        </div> */}

                        {/* profile details */}
                        <>
                          <div className="mdv_profiledtls p-3">
                            {console.log("dsfdsasfa", formValue)}
                            <Row className="mx-auto">
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                                className="mb-3 px-0"
                              >
                                <p className="mdv_inplabel">Enter City</p>
                                <input
                                  className="mdv_cmninput"
                                  type="text"
                                  id="City"
                                  placeholder="Enter City"
                                  value={formValue?.City || ""}
                                  onChange={(e) => OnChange(e)}
                                />
                                {Error && Error?.City && (
                                  <span className="error-msg">
                                    {Error.City}
                                  </span>
                                )}
                              </Col>
                            </Row>
                            <Row className=" mx-auto">
                              <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                                className="mb-3 px-0"
                              >
                                <p className="mdv_inplabel">Enter Zip Code</p>
                                <input
                                  className="mdv_cmninput"
                                  type="text"
                                  id="ZipCode"
                                  placeholder="Enter Zip Code"
                                  value={formValue?.ZipCode || ""}
                                  onChange={(e) => OnChange(e)}
                                />
                                {Error && Error?.ZipCode && (
                                  <span className="error-msg">
                                    {Error.ZipCode}
                                  </span>
                                )}
                              </Col>
                            </Row>
                            <div className="mdv_update_dualbtn">
                              <button
                                className="blue_btn mdv_update"
                                type="button"
                                onClick={() => Submit()}
                                disabled={Disable}
                              >
                                {formValue.action == "add"
                                  ? "Submit"
                                  : "Update"}
                              </button>
                            </div>
                          </div>
                        </>
                      </div>

                      {/* end of profile details */}
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LocationAction;
